var React = require('react');

function CocktailDuotone (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fa-group"},[React.createElement("path",{"className":"fa-secondary","d":"M208 280.27L264.28 224H151.72zM432 0c-62.6 0-115.34 40.2-135.17 96h52.53C366 67.45 396.63 48 432 48a96 96 0 0 1 0 192 95 95 0 0 1-39.32-8.64l-35.26 35.26A144 144 0 1 0 432 0z","opacity":"0.4","key":0}),React.createElement("path",{"className":"fa-primary","d":"M408.75 170.05c15.52-15.52 4.53-42.05-17.42-42.05H24.69c-22 0-32.94 26.53-17.42 42.05L176 338.78V464h-56a40 40 0 0 0-40 40 8 8 0 0 0 8 8h240a8 8 0 0 0 8-8 40 40 0 0 0-40-40h-56V338.78zM208 280.27L119.73 192h176.55z","key":1})]));
}

CocktailDuotone.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fad","data-icon":"cocktail","className":"svg-inline--fa fa-cocktail fa-w-18","role":"img","viewBox":"0 0 576 512"};

module.exports = CocktailDuotone;

CocktailDuotone.default = CocktailDuotone;
